import React from 'react';
import { bonuses } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Accordion } from './Accordion';
export function BonusSection() {
  return <section className="bg-[linear-gradient(180deg,#0D1F0F,#111A12)] px-5 py-10" data-id="element-35" data-mp="22fmxh06uic3p">
      <SectionTitle data-id="element-36" data-mp="22diuckgrth4h">🎁 Además te llevás estos bonos exclusivos de regalo</SectionTitle>

      <div className="mt-6 space-y-3" data-id="element-37" data-mp="1yet8e3ho2r98">
        {bonuses.map((bonus, i) => <Accordion key={bonus.id} id={bonus.id} className="bg-botanic" openClassName="bg-gold/[0.05]" header={<span className="flex items-start gap-3" data-id="element-39" data-mp="15qfbjr2be0z9">
                <span className="font-display text-[18px] font-bold text-gold" data-id="element-40" data-mp="1jgr3npywfzqe">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="font-sans text-[15px] font-semibold leading-snug text-ivory" data-id="element-41" data-mp="1ep9518kcmb8l">
                  {bonus.emoji} {bonus.title}
                </span>
              </span>} data-id="element-38" data-mp="1apiglbiao778" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-42" data-mp="mxtj7gqm8sjf">
              <img id={bonus.id} src={bonus.image} alt={`Portada del ${bonus.title}`} loading="lazy" decoding="async" width={120} height={160} className="h-[160px] w-[120px] rounded object-cover shadow-[0_12px_36px_rgba(201,168,76,0.28)]" data-id="element-43" data-mp="29s31pccn5la4" />
              <p className="mt-4 font-sans text-[15px] leading-relaxed text-ivory/85" data-id="element-44" data-mp="2jixnygpw0kvk">
                {bonus.description}
              </p>
            </div>
          </Accordion>)}
      </div>
    </section>;
}